export default "__VITE_ASSET__CZMNjaxH__"